'use strict';

/**
 * Flattens the list of `as`.
 *
 * @private
 */
function flatten(as) {
  return as.reduce(function (a, b) {
    return a.concat(b);
  }, []);
}

exports.flatten = flatten;
